import React from "react";
import { useTheme } from "next-themes";
import { Star } from "lucide-react";
import Iridescence from "./Iridescence";
import { IRIDESCENCE_DARK, IRIDESCENCE_LIGHT } from "../lib/iridescence";

const WorkStatsBanner = () => {
  const MemoIridescence = React.memo(Iridescence);
  const { theme } = useTheme();

  return (
    <div className="relative overflow-hidden rounded-2xl shadow-lg mt-16 text-center">
      <div className="absolute inset-0 bg-gradient-to-br from-[#f9fbff] via-white to-[#eef7ff] dark:from-[#07070b] dark:via-[#120b14] dark:to-[#2a0f0f]" />
      <div
        className="absolute inset-0 opacity-04 pointer-events-none dark:hidden"
        key={`light-${theme}`}
        style={{ transform: "scale(2)" }}
      >
        <MemoIridescence color={IRIDESCENCE_LIGHT} speed={0.08} amplitude={0.01} />
      </div>
      <div
        className="absolute inset-0 opacity-03 pointer-events-none hidden dark:block"
        key={`dark-${theme}`}
        style={{ transform: "scale(2)" }}
      >
        <MemoIridescence color={IRIDESCENCE_DARK} speed={0.08} amplitude={0.01} />
      </div>
      <div className="relative z-10 p-8 md:p-12">
        <div className="inline-grid grid-cols-2 grid-rows-2 md:grid-cols-4 md:grid-rows-1 gap-x-8 gap-y-8 text-center">
          <div className="group">
            <div className="text-3xl sm:text-4xl font-bold text-white mb-2">
              300+
            </div>
            <div className="text-sm sm:text-base text-white/80 font-medium">Equipos Reparados</div>
          </div>
          <div className="group">
            <div className="text-3xl sm:text-4xl font-bold text-white mb-2">
              98%
            </div>
            <div className="text-sm sm:text-base text-white/80 font-medium">Satisfacción</div>
          </div>
          <div className="group">
            <div className="text-3xl sm:text-4xl font-bold text-white mb-2">
              24h
            </div>
            <div className="text-sm sm:text-base text-white/80 font-medium">Tiempo Promedio</div>
          </div>
          <div className="group">
            <div className="text-3xl sm:text-4xl font-bold text-white mb-2 flex items-center justify-center gap-2">
              <span>5</span>
              <Star className="h-6 w-6 text-white fill-white" />
            </div>
            <div className="text-sm sm:text-base text-white/80 font-medium">Calificación</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkStatsBanner;
